/* eslint-disable */
import React, { useEffect, useContext } from "react";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonDateTime from "../../Common/CommonDateTime";
import { updateOrderManagementFilter } from "../../../redux/actions/adminActions";
import CommonTable from "../../Common/CommonTable";
import CommonLoader from "../../Common/CommonLoader";
import MainOrderDataTableFilter from "../../Common/MainOrderDataTableFilter";

var tab_url = "payment_approval_pending_edits";
const PaymentApprovalPendingWebsiteOrders = () => {
  const Dispatch = useDispatch();
  const { websocket } = useContext(WebSocketContext);
  const {
    device_id,
    OrderReportList,
    OrderManagmentFilter,
    sortingfor,
    selfInfo,
    commonMainLoader,
  } = useSelector((state) => state.adminReducers);
  const PermissionsAccess = selfInfo?.user?.permissions_access;

  // page change
  const currentFunction = (page) => {
    Dispatch(
      updateOrderManagementFilter({
        AllOrdersReport: {
          CurrentPage: page,
        },
      })
    );
  };

  // api calling
  const APICall = () => {
    const {
      UserLimit,
      UserSearch,
      SelectRegion,
      OrderSource,
      FromDate,
      ToDate,
      CurrentPage,
      WarehouseName,
      ProductName,
      is_bundle_orders,
    } = OrderManagmentFilter?.AllOrdersReport;

    let param = {
      transmit: "broadcast",
      url: "order_list",
      request: {
        status: "PAYMENT_PENDING",
        limit: UserLimit,
        page_no: CurrentPage,
        search: UserSearch.trim(),
        from_date: null,
        to_date: null,
        from_inv: null,
        to_inv: null,
        order_type: OrderSource,
        order_data: "list",
        region_id: SelectRegion,
        order_by: sortingfor,
        fetch_location_info: true,
        is_bundle_orders: is_bundle_orders,
        include_shipments: true,
      },
      DeviceId: device_id,
    };
    if (FromDate !== "" && ToDate !== "") {
      param.request.from_date = CommonDateTime(FromDate, "YYYY-MM-DD", "hide");
      param.request.to_date = CommonDateTime(ToDate, "YYYY-MM-DD", "hide");
    }
    if (WarehouseName) {
      param.request.warehouse_id = WarehouseName?.map(
        (elm) => elm?.value
      )?.toString();
    }
    if (ProductName) {
      param.request.product_id = ProductName?.map(
        (elm) => elm?.value
      )?.toString();
    }
    wsSend_request(websocket, param);
  };

  useEffect(() => {
    APICall();
  }, [websocket, OrderManagmentFilter?.AllOrdersReport]);

  useEffect(() => {
    if (sortingfor !== "" && sortingfor !== "-") {
      APICall();
    }
  }, [sortingfor]);

  // TABLE COLUMNS ARRAY
  const TableColumns = [
    {
      key: "order_code",
      label: "Order Id.",
      type: "order_details",
      sort: "order_code",
      isCollapsable: false,
    },
    {
      key: "customer_name",
      label: "SHIP To Name",
      type: "label",
      sort: "customer_name",
      isCollapsable: false,
    },
    {
      key: "pin_code",
      label: "SHIP Pincode",
      type: "label",
      sort: "pin_code_id",
      isCollapsable: false,
    },
    {
      key: "state",
      label: "SHIP State",
      type: "label",
      sort: "state_id",
      isCollapsable: false,
    },
    {
      key: "district",
      label: "SHIP City",
      type: "label",
      sort: "district_id",
      isCollapsable: false,
    },
    {
      key: "created_at",
      label: "Order Date",
      type: "date",
      sort: "created_at",
      isCollapsable: false,
    },
    {
      key: "updated_at",
      label: "Pending Since",
      type: "pending_since",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "order_status",
      label: "Status",
      type: "label_order_status",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "payment_id",
      label: "Payment ID",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "payment_date",
      label: "Payment Date",
      type: "date",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "payment_method",
      label: "Payment Mode",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "emi_amount",
      label: "EMI Amount",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "emi_tenure",
      label: "EMI Tenure",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "down_payment",
      label: "Down Payment",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
  ];

  return (
    <section className="Main_section" style={{ position: "relative" }}>
      {/* COMMON FILTER */}
      <MainOrderDataTableFilter
        filterType={""}
        tabName={"AllOrdersReport"}
        searchType={"Order Id, Customer Code"}
        FromDateStartDateFlag={true}
        searchdisable={true}
        buttonvisible={false}
        AllOrderStatusAllow={false}
        isAllowWarehouse={false}
        isAllowProduct={false}
        isDateType={false}
        isOdiFilterAllow={false}
        isRegionAllow={false}
        isBundleOrdersAllow={false}
        isOrderSourceAllow={false}
      />

      {/* COMMON TABLE */}
      <CommonTable
        isTableAllow={true}
        style={{
          height:
            parseInt(OrderReportList?.pagination?.total_records) ===
            OrderReportList?.list?.length
              ? "calc(100vh - 196px)"
              : parseInt(OrderReportList?.pagination?.total_records) > 10
              ? "calc(100vh - 235px)"
              : "calc(100vh - 196px)",
        }}
        srNumber={{
          clickable: true,
          events: "ORDERS_LOG",
        }}
        isCollapsable={true}
        tabName={""} // TAB URL
        PaginationCurrentPage={
          OrderManagmentFilter["AllOrdersReport"]?.CurrentPage
        } // TAB CURRENT PAGE
        PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
        TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
        OrderList={OrderReportList} // ORDER LIST
        Pagination={OrderReportList?.pagination} // CURRENT TAB PAGINATION
        EditAccess={selfInfo?.user?.user_type === "super_admin"} // EDITABLE ACCESS STATE
        APIcalling={APICall}
        isActionColumnAvailable={{
          isShow: selfInfo?.user?.user_type === "super_admin",
          label: "orders_payment_approval",
          naviagte: null,
        }}
      />

      {commonMainLoader?.url === "add_payment_detail" &&
        commonMainLoader?.loader && <CommonLoader />}
    </section>
  );
};

export default PaymentApprovalPendingWebsiteOrders;
